/* ============================================================
   Compra rápida da coleção Desconto Progressivo
   - Só na coleção desconto-progressivo-1.
   - Clicar num card do produto NÃO vai pra PDP: abre um modal de
     variação (Cor/Tamanho) e adiciona ao carrinho ali mesmo.
   - Após adicionar, fecha o modal e MANTÉM o usuário na coleção
     (a barra de progresso atualiza via cart:updated + interceptor de /cart/add).
   ============================================================ */
(function () {
  // Defensivo: só ativa na coleção alvo (o asset já é carregado só lá, mas garante).
  if (!/\/collections\/desconto-progressivo-1\b/.test(location.pathname)) return;

  var PIX = parseFloat(window.DP_PIX_DISCOUNT || 0) || 0; // % de desconto no Pix

  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function pixPrice(cents) { return PIX > 0 ? Math.round(cents * (1 - PIX / 100)) : cents; }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, '-');
  }

  /* ---------- estado ---------- */
  var product = null;   // produto carregado (/products/handle.js)
  var selected = [];    // valor selecionado por índice de opção

  /* ---------- monta o modal uma única vez ---------- */
  var modal = document.createElement('div');
  modal.className = 'dpqb';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.innerHTML =
    '<div class="dpqb__overlay" data-dpqb-close></div>' +
    '<div class="dpqb__content">' +
      '<button class="dpqb__close" type="button" aria-label="Fechar" data-dpqb-close>&times;</button>' +
      '<div class="dpqb__left"><div class="dpqb__image">' +
        '<img id="dpqb-img" src="" alt="" width="300" height="300" loading="lazy"></div></div>' +
      '<div class="dpqb__right">' +
        '<div class="dpqb__header">Adicionar ao kit</div>' +
        '<h4 class="dpqb__title"></h4>' +
        '<div class="dpqb__options"></div>' +
        '<p class="dpqb__error">Essa combinação está indisponível. Escolha outra.</p>' +
        '<div class="dpqb__price"></div>' +
        '<button class="dpqb__add" type="button">Adicionar ao carrinho</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  var elImg     = modal.querySelector('#dpqb-img');
  var elTitle   = modal.querySelector('.dpqb__title');
  var elOptions = modal.querySelector('.dpqb__options');
  var elPrice   = modal.querySelector('.dpqb__price');
  var elAdd     = modal.querySelector('.dpqb__add');

  /* ---------- abrir / fechar ---------- */
  function openModal() { modal.classList.add('is-open'); document.body.classList.add('dpqb-open'); }
  function closeModal() { modal.classList.remove('is-open', 'has-error'); document.body.classList.remove('dpqb-open'); }

  modal.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-dpqb-close')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  /* ---------- variantes ---------- */
  function matchVariant(vals) {
    return (product.variants || []).find(function (v) {
      return vals.every(function (val, i) { return v.options[i] === val; });
    }) || null;
  }
  function optionValues(i) {
    var seen = {}, out = [];
    (product.variants || []).forEach(function (v) {
      var val = v.options[i];
      if (!(val in seen)) { seen[val] = true; out.push(val); }
    });
    return out;
  }
  function valueHasStock(i, val) {
    return (product.variants || []).some(function (v) { return v.options[i] === val && v.available; });
  }

  /* ---------- render ---------- */
  function render() {
    elTitle.textContent = product.title;

    if ((product.variants || []).length <= 1) {
      elOptions.innerHTML = ''; // produto sem variação: só adicionar
    } else {
      var names = product.options || [];
      elOptions.innerHTML = names.map(function (name, i) {
        var opts = optionValues(i).map(function (val) {
          var stock = valueHasStock(i, val);
          var sel = selected[i] === val ? ' selected' : '';
          return '<option value="' + esc(val) + '"' + sel + (stock ? '' : ' disabled') + '>' +
            esc(val) + (stock ? '' : ' (esgotado)') + '</option>';
        }).join('');
        return '<div class="dpqb__option"><label>' + esc(name) + '</label>' +
          '<select data-opt="' + i + '">' + opts + '</select></div>';
      }).join('');

      [].forEach.call(elOptions.querySelectorAll('select'), function (sel) {
        sel.addEventListener('change', function () {
          selected[parseInt(sel.getAttribute('data-opt'), 10)] = sel.value;
          update();
        });
      });
    }
    update();
  }

  function update() {
    var v = matchVariant(selected);

    var img = (v && v.featured_image) || product.featured_image || '';
    if (img) { elImg.src = img; elImg.alt = product.title; }

    if (v) renderPrice(v);

    if (v && v.available) {
      modal.classList.remove('has-error');
      elAdd.disabled = false;
      elAdd.dataset.variantId = v.id;
    } else {
      modal.classList.add('has-error');
      elAdd.disabled = true;
      delete elAdd.dataset.variantId;
    }
  }

  function renderPrice(v) {
    var now = pixPrice(v.price);
    var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
    var inst = Math.round(v.price / 3);
    var html = '';
    if (compare) html += '<span class="dpqb__price-compare">' + brl(compare) + '</span>';
    html += '<span class="dpqb__price-now">' + brl(now) + (PIX > 0 ? ' no Pix' : '') + '</span>';
    html += '<span class="dpqb__price-installments">ou 3x de ' + brl(inst) + ' sem juros</span>';
    elPrice.innerHTML = html;
  }

  /* ---------- abre o modal INSTANTÂNEO a partir do JSON embutido no card ---------- */
  function openProduct(p, preferColor) {
    product = p;

    var first = (p.variants || []).find(function (v) { return v.available; }) || (p.variants || [])[0];
    selected = first ? first.options.slice() : [];

    // pré-seleciona a cor que estava ativa no swatch do card, se houver
    if (preferColor && (p.options || []).length) {
      var ci = (p.options).findIndex(function (n) { return /cor|color|colour/i.test(n); });
      if (ci >= 0) {
        var match = (p.variants || []).find(function (v) { return slug(v.options[ci]) === slug(preferColor) && v.available; }) ||
          (p.variants || []).find(function (v) { return slug(v.options[ci]) === slug(preferColor); });
        if (match) selected = match.options.slice();
      }
    }

    elAdd.classList.remove('is-added');
    elAdd.textContent = 'Adicionar ao carrinho';
    modal.classList.remove('has-error');
    render();    // preenche imagem, opções e preço
    openModal(); // abre já populado (sem "Carregando")
  }

  /* ---------- adicionar ao carrinho (sem abrir o drawer) ---------- */
  elAdd.addEventListener('click', function () {
    var id = elAdd.dataset.variantId;
    if (!id || elAdd.disabled) return;
    elAdd.disabled = true;
    elAdd.textContent = 'Adicionando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (data) {
        updateCartUI(data && data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated')); // barra de progresso
        elAdd.classList.add('is-added');
        elAdd.textContent = '✓ Adicionado';
        setTimeout(closeModal, 850);
      })
      .catch(function () {
        elAdd.disabled = false;
        elAdd.textContent = 'Adicionar ao carrinho';
        modal.classList.add('has-error');
      });
  });

  // Atualiza ícone do carrinho + conteúdo do cart drawer a partir das sections
  // retornadas, SEM abrir o drawer (mantém o usuário na coleção).
  function updateCartUI(sections) {
    if (!sections) return;
    try {
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var src = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && src) bubble.innerHTML = src.innerHTML;
      }
      if (sections['cart-drawer']) {
        // Re-render COMPLETO do #CartDrawer (mesma estratégia do renderContents do tema),
        // mas SEM abrir o drawer. Recriar o conteúdo inteiro evita o estado inconsistente
        // de carrinho vazio->cheio: o bloco .drawer__inner-empty (só renderizado quando o
        // carrinho estava vazio na carga) sobrava no update parcial e quebrava o layout.
        var drawer = document.querySelector('cart-drawer');
        var current = document.getElementById('CartDrawer');
        var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (current && fresh) {
          current.innerHTML = fresh.innerHTML;
          // o overlay foi recriado -> religa o "fechar ao clicar fora" (igual o renderContents)
          var overlay = current.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer && typeof drawer.close === 'function') {
            overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        if (drawer) drawer.classList.remove('is-empty');
      }
    } catch (e) { /* silencioso: o add já foi feito */ }
  }

  /* ---------- intercepta o clique no card: abre o modal na hora ---------- */
  document.addEventListener('click', function (e) {
    // não intercepta swatch de cor, badges ou elementos marcados
    if (e.target.closest('product-card-color-swatch, .card__badge, [data-dpqb-ignore]')) return;

    var card = e.target.closest('.card-wrapper');
    if (!card) return;
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    // JSON do produto embutido no card (sem fetch -> abre instantâneo)
    var dataEl = card.querySelector('[data-dpqb-product]');
    if (!dataEl) return; // sem dados -> deixa navegar normalmente pra PDP

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

    e.preventDefault();
    e.stopPropagation();

    var active = card.querySelector('[data-selected="true"]');
    openProduct(data, active ? active.getAttribute('data-color') : null);
  }, true); // capture: intercepta antes da navegação do link
})();
